// Copyright (c) 2021 WiseTime. All rights reserved.

import React from "react"
import { useDispatch } from "react-redux"
import {
  convertMonthDateToDateTime,
  convertTimeLineMonthToTimelineTrashPathDate,
  getCurrentMonth,
  getMonthYearLabel,
  isFutureMonth,
  TimelineMonth,
} from "features/timeline/dateTime"
import * as TrashedTimeRowSlice from "../trash/slice"
import { DateLinkWrapper, DateLink, DateLabel } from "../../shared/styles"
import DateTabIndicatorTrash from "./DateTabIndicatorTrash"
import { ROUTE_PATH } from "app/routing"

type Props = {
  timelineMonth: TimelineMonth,
  isActive: boolean,
}

const DateTabTrash = ({ timelineMonth, isActive }: Props): React.ReactElement<Props> => {
  const dispatch = useDispatch()
  const onClick = (): void => {
    dispatch(TrashedTimeRowSlice.setActiveTrashMonth({ activeTrashMonth: timelineMonth }))
  }
  return (
    <DateLinkWrapper isActive={isActive}>
      <DateLink
        to={ROUTE_PATH.TRASH.path.replace(
          ":month?",
          convertTimeLineMonthToTimelineTrashPathDate(timelineMonth),
        )}
        onClick={onClick}
        activeClassName="is-active"
        className={getCurrentMonth() === timelineMonth ? "is-today" : ""}
        replace={isActive}
      >
        <DateLabel>
          {getMonthYearLabel(convertMonthDateToDateTime(timelineMonth))}
        </DateLabel>
        <DateTabIndicatorTrash
          isFuture={isFutureMonth(timelineMonth)}
          timelineMonth={timelineMonth}
        />
      </DateLink>
    </DateLinkWrapper>
  )
}

export default DateTabTrash
